import { GuennieRating } from './GuennieRating';
import { KRITERIUM_LABEL, KRITERIUM_HILFE, type Kriterium } from '../lib/kriterien';

/**
 * Eine Bewertungszeile im Verkostungsformular (Anlegen wie Bearbeiten):
 * Kriteriumsname + Hilfetext + Günnie-Eingabe. Ausgelagert aus
 * NeueVerkostung.tsx, damit VerkostungBearbeiten.tsx sie mitbenutzen kann.
 */
export function KriteriumZeile({
  k,
  wert,
  onChange,
  pflicht,
}: {
  k: Kriterium;
  wert: number | undefined;
  onChange: (v: number) => void;
  pflicht?: boolean;
}) {
  return (
    <div style={{ padding: '0.6rem 0', borderBottom: '1px solid var(--raspel)' }}>
      <div style={{ fontWeight: 600 }}>
        {KRITERIUM_LABEL[k]} {pflicht ? <span style={{ color: 'var(--erdbeere)' }}>*</span> : null}
      </div>
      {KRITERIUM_HILFE[k] ? (
        <div style={{ fontSize: '0.85rem', color: 'var(--espresso-70)' }}>{KRITERIUM_HILFE[k]}</div>
      ) : null}
      <div style={{ marginTop: '0.35rem' }}>
        <GuennieRating wert={wert ?? null} eingabe onChange={onChange} label={KRITERIUM_LABEL[k]} />
      </div>
    </div>
  );
}
